import { supabaseClient } from './supabaseClient.js';

// Hàm lấy danh sách Wallets (Chỉ lấy các ví đang Active)
export async function fetchWallets() {
    console.log('[API] Đang tải Wallets...');
    const { data, error } = await supabaseClient
        .from('wallets')
        .select('*')
        .eq('is_active', true)
        .order('usage_count', { ascending: false });
    if (error) { console.error('[API] Lỗi tải Wallets:', error.message); return []; }
    return data;
}

// Xoá mềm Wallet (Chuyển is_active về false)
export async function deleteWallet(walletId) {
    console.log(`[API] Đang xoá mềm Wallet: ${walletId}`);
    const { data, error } = await supabaseClient
        .from('wallets')
        .update({ is_active: false })
        .eq('id', walletId)
        .select();

    if (error) { console.error('[API] Lỗi xoá Wallet:', error.message); return false; }
    return true;
}

// 1. Tạo mới Wallet (Mặc định loại là 'other')
export async function createWallet(name) {
    console.log(`[API] Đang tạo Wallet mới: ${name}`);
    const { data, error } = await supabaseClient.from('wallets').insert([{ name: name, type: 'other', usage_count: 1 }]).select().single();
    if (error) { console.error('[API] Lỗi tạo Wallet:', error.message); return null; }
    return data;
}

// 5. Tạo Ví mới chuyên sâu (Từ Tab Wallets)
export async function createWalletFull(name, type, currency, balance) {
    console.log(`[API] Đang tạo Wallet mới: ${name} | ${type} | ${currency} | Balance: ${balance}`);
    const { data, error } = await supabaseClient.from('wallets').insert([{
        name: name,
        type: type,
        currency: currency,
        balance: balance,
        usage_count: 1
    }]).select().single();

    if (error) {
        console.error('[API] Lỗi tạo Wallet:', error.message);
        return null;
    }
    return data;
}

// Cập nhật tên Wallet
export async function updateWallet(walletId, newName) {
    const { data, error } = await supabaseClient
        .from('wallets')
        .update({ name: newName })
        .eq('id', walletId)
        .select()
        .single();
    if (error) { console.error('[API] Lỗi sửa Wallet:', error.message); return null; }
    return data;
}

